
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PsConfigGrid extends Serenity.EntityGrid<PsConfigRow, any> {
        protected getColumnsKey() { return PsConfigColumns.columnsKey; }
        protected getDialogType() { return PsConfigDialog; }
        protected getIdProperty() { return PsConfigRow.idProperty; }
        protected getInsertPermission() { return PsConfigRow.insertPermission; }
        protected getLocalTextPrefix() { return PsConfigRow.localTextPrefix; }
        protected getService() { return PsConfigService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
			var button = super.getButtons();

            button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
            
            button.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: PsConfigService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
                
                button.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );            
                
			// button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
			return button;
		}
    }
}